var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import PropertiesConstants from "@components/common/constants/PropertiesConstants";
import BeoDropDown from "@components/common/input/BeoDropDown/BeoDropDown";
import BeoMessages from "@components/common/view/BeoMessages/BeoMessages";
import { setGlobalLocale, setUserInfo, useBEOController, } from "@context/BeoContext";
import { useThemeSwitcher } from "@hooks/ThemeSwitcher";
import { updateUserConfigurations } from "@services/user/UserService";
import { getUserName } from "@utils/auth";
import { Accordion, AccordionTab } from "primereact/accordion";
import { useCallback, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { languagedata, themeData } from "./Themes";
/**
 * ThemeComponents allows users to customize their application preferences,
 * including theme, language, and feature visibility (user card, message card, client card).
 * Changes are automatically saved to user preferences.
 *
 * @component
 * @author niyas.shajahan
 * @since 2025-06-19
 */
var ThemeComponents = function () {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u;
    /**
     * Loads localized constants for properties.
     * @type {object}
     */
    var localizedConstants = PropertiesConstants();
    /**
     * Hook for applying theme changes.
     * @type {object}
     * @property {function(string): void} applyTheme - Function to apply a new theme.
     */
    var applyTheme = useThemeSwitcher().applyTheme;
    /**
     * React i18next hook for accessing internationalization functions.
     * @type {object}
     * @property {object} i18n - The i18n instance.
     */
    var i18n = useTranslation().i18n;
    /**
     * Retrieves context and dispatch function from useBEOController.
     * @type {Array<object, function>}
     */
    var _v = useBEOController(), context = _v[0], dispatch = _v[1];
    /**
     * Ref for the `BeoMessages` component to display transient messages (e.g., save errors).
     * @type {React.MutableRefObject<any>}
     */
    var msgs = useRef(null);
    /**
     * State to manage user preferences.
     * Initializes with values from context or defaults.
     * @type {[object, function]}
     * @property {string} theme - Current theme.
     * @property {string} language - Current language.
     * @property {boolean} fieldsetToggle - State of the fieldset toggle feature.
     * @property {boolean} showUserCard - State for showing the user dashboard card.
     * @property {boolean} showMessageCard - State for showing the message dashboard card.
     * @property {boolean} showClientCard - State for showing the client dashboard card.
     */
    var _w = useState({
        theme: context.userInfo.theme || "lara-light-blue",
        language: context.userInfo.language || "de",
        fieldsetToggle: (_c = (_b = (_a = context.userInfo) === null || _a === void 0 ? void 0 : _a.userFeatures) === null || _b === void 0 ? void 0 : _b.fieldsetToggle) !== null && _c !== void 0 ? _c : false,
        showUserCard: (_f = (_e = (_d = context.userInfo) === null || _d === void 0 ? void 0 : _d.userFeatures) === null || _e === void 0 ? void 0 : _e.showUserCard) !== null && _f !== void 0 ? _f : true,
        showMessageCard: (_j = (_h = (_g = context.userInfo) === null || _g === void 0 ? void 0 : _g.userFeatures) === null || _h === void 0 ? void 0 : _h.showMessageCard) !== null && _j !== void 0 ? _j : true,
        showClientCard: (_m = (_l = (_k = context.userInfo) === null || _k === void 0 ? void 0 : _k.userFeatures) === null || _l === void 0 ? void 0 : _l.showClientCard) !== null && _m !== void 0 ? _m : true,
        defaultRecordCount: (_q = (_p = (_o = context.userInfo) === null || _o === void 0 ? void 0 : _o.userFeatures) === null || _p === void 0 ? void 0 : _p.defaultRecordCount) !== null && _q !== void 0 ? _q : 30,
        defaultMsgTabRecordCount: (_t = (_s = (_r = context.userInfo) === null || _r === void 0 ? void 0 : _r.userFeatures) === null || _s === void 0 ? void 0 : _s.defaultMsgTabRecordCount) !== null && _t !== void 0 ? _t : 3,
    }), preferences = _w[0], setPreferences = _w[1];
    /**
     * Effect hook to change the i18n language and update the global locale
     * in context whenever `preferences.language` changes.
     */
    useEffect(function () {
        i18n.changeLanguage(preferences.language, function () {
            return setGlobalLocale(dispatch, preferences.language);
        });
    }, [preferences.language, i18n, dispatch]);
    /**
     * Memoized callback to handle theme changes.
     * Updates local preferences and applies the new theme globally.
     * @param {DropdownChangeEvent} e - The dropdown change event object.
     */
    var handleThemeChange = useCallback(function (e) {
        var newTheme = e.value;
        setPreferences(function (prev) { return (__assign(__assign({}, prev), { theme: newTheme })); });
        applyTheme(newTheme);
    }, [applyTheme]);
    /**
     * Memoized callback to handle language changes.
     * Updates the language in local preferences.
     * @param {DropdownChangeEvent} e - The dropdown change event object.
     */
    var handleLanguageChange = useCallback(function (e) {
        setPreferences(function (prev) { return (__assign(__assign({}, prev), { language: e.value })); });
    }, []);
    /**
     * Memoized callback to save user preferences to the backend.
     * Constructs the `UserPreferences` object and calls `saveUserPreference`.
     * Displays an error message if saving fails.
     */
    var handleSave = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var userConfigData, updatedUserDto, error_1;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 2, , 3]);
                    if (!((_a = context.userInfo) === null || _a === void 0 ? void 0 : _a.username)) {
                        console.warn("User info not available, cannot save preferences.");
                        return [2 /*return*/];
                    }
                    userConfigData = {};
                    updatedUserDto = __assign(__assign({}, userConfigData), { userId: getUserName(), theme: preferences.theme, language: preferences.language });
                    return [4 /*yield*/, updateUserConfigurations(updatedUserDto, {
                            onSuccess: function (res) {
                                console.log("configUpdateResponse " + res);
                                if ((res === null || res === void 0 ? void 0 : res.responseBody) === 1) {
                                    console.log("Confiuration updated successfully");
                                }
                            },
                            onError: function (error) {
                                var _a;
                                console.error("Error saving preferences:", error);
                                (_a = msgs.current) === null || _a === void 0 ? void 0 : _a.show([
                                    {
                                        severity: "error",
                                        summary: "Error",
                                        detail: "An unexpected error occurred while saving preferences.",
                                    },
                                ]);
                            },
                        })];
                case 1:
                    _c.sent();
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _c.sent();
                    console.error("Error saving preferences:", error_1);
                    (_b = msgs.current) === null || _b === void 0 ? void 0 : _b.show([
                        {
                            severity: "error",
                            summary: "Error",
                            detail: "An unexpected error occurred while saving preferences.",
                        },
                    ]);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); }, [(_u = context.userInfo) === null || _u === void 0 ? void 0 : _u.username, preferences]);
    /**
     * Effect hook to trigger an auto-save operation whenever `preferences` change.
     * Uses a debounce mechanism (2-second timeout) to prevent excessive API calls.
     * Cleans up the timer on unmount or if preferences change again before timeout.
     */
    useEffect(function () {
        handleSave();
        setUserInfo(dispatch, __assign(__assign({}, context.userInfo), { theme: preferences.theme, language: preferences.language, userFeatures: {
                fieldsetToggle: preferences.fieldsetToggle,
                showUserCard: preferences.showUserCard,
                showMessageCard: preferences.showMessageCard,
                showClientCard: preferences.showClientCard,
                defaultRecordCount: preferences.defaultRecordCount,
                defaultMsgTabRecordCount: preferences.defaultMsgTabRecordCount,
            } }));
    }, [preferences]);
    return (_jsxs("div", { className: "p-3 shadow-lg rounded-2xl max-w-md  space-y-3", children: [_jsx("h2", { className: "text-lg font-semibold ml-auto", children: localizedConstants.settings.customizePreferences }), _jsx(Accordion, { multiple: true, children: _jsx(AccordionTab, { header: localizedConstants.settings.generalSettings, children: _jsxs("div", { className: "space-y-2", children: [_jsxs("div", { children: [_jsx("label", { htmlFor: "theme-drop", className: "block mb-1", children: localizedConstants.settings.theme }), _jsx(BeoDropDown, { id: "theme", inputId: "theme-drop", value: preferences.theme, onChange: handleThemeChange, options: themeData, optionLabel: "label", className: "w-full" })] }), _jsxs("div", { children: [_jsx("label", { htmlFor: "language-drop", className: "block mb-1", children: localizedConstants.settings.language }), _jsx(BeoDropDown, { id: "language", inputId: "language-drop", value: preferences.language, onChange: handleLanguageChange, options: languagedata, optionLabel: "label", className: "w-full" })] })] }) }) }), _jsx("div", { className: "flex justify-center mt-4", children: _jsx(BeoMessages, { className: "w-full", id: "msg", ref: msgs }) })] }));
};
export default ThemeComponents;
